"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAdmin = createAdmin;
exports.createUser = createUser;
exports.editAdmin = editAdmin;
exports.getEmployees = getEmployees;
exports.getUserByPhone = getUserByPhone;
exports.getUserByPhoneOrEmail = getUserByPhoneOrEmail;
exports.userWatcher = userWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(userWatcher);
function getUserByPhone(_ref) {
  var payload = _ref.payload,
    meta = _ref.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _response$data, response, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.UserService.getByPhone, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_USER_BY_PHONE_SUCCESS,
            payload: response
          });
        case 6:
          meta === null || meta === void 0 || meta.callback((_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : {});
          _context.next = 14;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables.GET_USER_BY_PHONE_FAIL,
            payload: _response
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  })();
}
function createAdmin(_ref3) {
  var payload = _ref3.payload,
    meta = _ref3.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var _response$data2, response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.UserService.createAdmin, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_ADMIN_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Staff member created successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback((_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
          _context2.next = 19;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_ADMIN_FAIL,
            payload: _response2
          });
        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 18:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })();
}
function createUser(_ref5) {
  var payload = _ref5.payload,
    meta = _ref5.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var _response$data3, response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.UserService.createUser, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_USER_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'User created successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback((_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : {});
          _context3.next = 19;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_USER_FAIL,
            payload: _response3
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}
function editAdmin(_ref7) {
  var payload = _ref7.payload,
    meta = _ref7.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var _response$data4, response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.UserService.editAdmin, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_ADMIN_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Staff member updated successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback((_response$data4 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data4 !== void 0 ? _response$data4 : {});
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.EDIT_ADMIN_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function getUserByPhoneOrEmail(_ref9) {
  var payload = _ref9.payload,
    meta = _ref9.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var _response$data5, response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.UserService.getByPhoneOrEmail, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_USER_BY_PHONE_OR_EMAIL_SUCCESS,
            payload: response
          });
        case 6:
          meta === null || meta === void 0 || meta.callback((_response$data5 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data5 !== void 0 ? _response$data5 : {});
          _context5.next = 17;
          break;
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 14;
          return (0, _effects.put)({
            type: _variables.GET_USER_BY_PHONE_OR_EMAIL_FAIL,
            payload: _response5
          });
        case 14:
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 16:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 9]]);
  })();
}
function getEmployees(_ref11) {
  var payload = _ref11.payload,
    meta = _ref11.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var _response$data6, response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.UserService.getEmployees, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables.GET_EMPLOYEES_SUCCESS,
            payload: response
          });
        case 6:
          meta === null || meta === void 0 || meta.callback((_response$data6 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data6 !== void 0 ? _response$data6 : {});
          _context6.next = 17;
          break;
        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 14;
          return (0, _effects.put)({
            type: _variables.GET_EMPLOYEES_FAIL,
            payload: _response6
          });
        case 14:
          _context6.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 16:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 9]]);
  })();
}
function userWatcher() {
  return _regenerator["default"].wrap(function userWatcher$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.CREATE_USER_REQUEST, createUser), (0, _effects.takeLatest)(_variables.GET_USER_BY_PHONE_REQUEST, getUserByPhone), (0, _effects.takeLatest)(_variables.GET_USER_BY_PHONE_OR_EMAIL_REQUEST, getUserByPhoneOrEmail), (0, _effects.takeLatest)(_variables.GET_EMPLOYEES_REQUEST, getEmployees), (0, _effects.takeLatest)(_variables.CREATE_ADMIN_REQUEST, createAdmin), (0, _effects.takeLatest)(_variables.EDIT_ADMIN_REQUEST, editAdmin)]);
      case 2:
      case "end":
        return _context7.stop();
    }
  }, _marked);
}